const setActiveItemIndexAndScroll = (navigation, setActiveIndex) => {
  const scrollTo = element => {
    const container = document.getElementById('in-page-subnav');
    const elementLeft = element.offsetLeft;
    const elementWidth = element.offsetWidth;
    const windowWidth = window.innerWidth;
    const scrollToCenter = elementLeft - container.scrollLeft - windowWidth / 2 + elementWidth / 2;

    container.scrollBy({
      left: scrollToCenter,
      behavior: 'smooth',
    });
  };

  const scrollToAnchorSetActiveIndex = new IntersectionObserver(
    entries => {
      entries.forEach(({ isIntersecting, target }) => {
        if (isIntersecting) {
          const id = target.getAttribute('id');
          const index = navigation?.navigation?.findIndex(
            item => id === `section-${item?.url?.split('#')[1]}`
          );
          const contentfulId = id.split('-')[1];
          const selectedLabel = document.getElementById(`label-${contentfulId}`);

          scrollTo(selectedLabel);
          setActiveIndex(index);
        }
      });
    },
    { rootMargin: '0px', threshold: '0.5' }
  );

  navigation?.navigation?.forEach(item => {
    const anchor = `section-${item?.url?.split('#')[1]}`;
    const heading = document.getElementById(anchor);
    if (heading?.nodeType == 1) {
      scrollToAnchorSetActiveIndex?.observe(heading);
    }
  });
};

export default setActiveItemIndexAndScroll;
